import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Swiper from 'react-id-swiper'
import { withRouter } from 'react-router-dom'
import Picture from '../../_common/Picture'
import PROCESS from '../../../content/processContent'
import { View, H3, H4 } from '../../typography'
import { MOBILE_VIEW, TABLET_VIEW } from '../../../constants/dimentions'
import './style.css'

class ProcessSlider extends Component {
  static propTypes = {
    screenWidth: PropTypes.number,
    match: PropTypes.shape({
      params: PropTypes.shape({})
    })
  }

  state = {
    currentIndex: 0
  }

  componentDidMount () {
    this.setCurrentItem()
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { match } = this.props
    if (prevProps.match.params !== match.params) {
      this.setCurrentItem()
    }
  }

  setCurrentItem = () => {
    const { match } = this.props
    const currentIndex = match.params && PROCESS.stages.findIndex(stage => stage.slug === match.params.slug)
    this.setState({ currentIndex })
    this.processSlider && this.processSlider.slideTo(currentIndex + 1)
  }

  CURRENT_STAGE_INDEX = (index, arr) => {
    if (index <= arr.length - 1) return index
    return 0
  }

  NEXT_STAGE_INDEX = (index, arr) => {
    if (index === arr.length - 1) return 0
    if (index === arr.length) return 1
    return index + 1
  }

  onNext = () => {
    const { currentIndex } = this.state
    this.setState({ currentIndex: this.NEXT_STAGE_INDEX(currentIndex, PROCESS.stages) })
    this.processSlider && this.processSlider.slideNext()
  }

  onPrev = () => {
    const { currentIndex } = this.state
    this.setState({ currentIndex: this.CURRENT_STAGE_INDEX(currentIndex, PROCESS.stages) })
    this.processSlider.slidePrev()
  }

  onSlideChange = (index) => {
    this.setState({ currentIndex: index })
  }

  render () {
    const { title, subTitle, stages } = PROCESS
    const { currentIndex } = this.state
    const { screenWidth } = this.props

    const processSliderParams = {
      slidesPerView: 1,
      loop: true,
      speed: 500,
      history: {
        replaceState: true,
        key: ''
      },
      mousewheel: {
        sensitivity: 10
      },
      allowTouchMove: true,
      direction: screenWidth > TABLET_VIEW ? 'vertical' : 'horizontal',
      pagination: {
        el: '.aside-pagination',
        clickable: false,
        bulletClass: 'aside-pagination-bullet',
        renderBullet: (index, className) => (`<span class="${className}">0${index + 1}</span>`)
      },
      on: {
        transitionStart: () => this.onSlideChange(this.processSlider && this.processSlider.realIndex)
      },
      getSwiper: (sw) => { this.processSlider = sw }
    }

    const setStageNumber = () => {
      if (currentIndex && PROCESS && PROCESS.stages.length) {
        return PROCESS.stages[this.NEXT_STAGE_INDEX(currentIndex, PROCESS.stages)].number
      }
      return PROCESS.stages[1].number
    }

    const setStageName = () => {
      if (currentIndex && PROCESS && PROCESS.stages.length) {
        return PROCESS.stages[this.NEXT_STAGE_INDEX(currentIndex, PROCESS.stages)].name
      }
      return PROCESS.stages[1].name
    }

    return (
      <div className='process-slider'>
        {screenWidth <= MOBILE_VIEW &&
        <div className='title process-slider__mobile-title'><span className='title__route-name'>approach /</span> process</div>}
        <div className='process-slider__titles'>
          <h1 className='title process-slider__title'>{title}</h1>
          <div className='process-slider__subtitle-wrapper'>
            <h2 className='process-slider__subtitle'>{subTitle}</h2>
          </div>
        </div>
        <div className='process-slider__wrapper'>
          <Swiper {...processSliderParams}>
            {
              stages.map(stage => (
                <div key={stage.number} data-history={stage.slug}>
                  <div className='process-slider__content'>
                    <div className='img-block'>
                      <div className='img__bg' />
                      <div className='img__wrapper'>
                        <Picture {...stage.imgSet} className='img__picture' />
                      </div>
                    </div>
                    <div className='text-block'>
                      <H3 className='stage-number'>{stage.number}</H3>
                      <H4 className='stage-name'>{stage.name}</H4>
                      <View className='stage-text'>{stage.text}</View>
                    </div>
                  </div>
                </div>
              ))
            }
          </Swiper>
        </div>
        <div className='process-slider__nav-container'>
          <div className='process-slider__next-slide-line'>
            <button type='button' className='process-slider__arrow process-slider__arrow-up' onClick={this.onPrev} />
            <button type='button' className='process-slider__arrow process-slider__arrow-down' onClick={this.onNext} />
            {screenWidth > MOBILE_VIEW &&
            (
              <div>
                <span className='process-slider__next-slide-num'>
                  {setStageNumber()}
                </span>
                <span className='process-slider__next-slide-name'>
                  {setStageName()}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(ProcessSlider)
